import { linksConstants } from "../../../../constants/linksConstants";
import { format } from "date-fns";
import { FiRadio, FiTv, FiArrowRight } from "react-icons/fi";
import clsx from "clsx";
import { slugify } from "../../../../utils/slugify";
import Link from "next/link";

export const WebinarCard = ({ webinar, upcoming = false }) => {
  const date = new Date(webinar.date);
  const time = format(date, "hh:mm a").replace(/^(?:00:)?0?/, "");

  return (
    <Link
      href={
        new URL(
          webinar.webinar_registration_link !== ""
            ? webinar.webinar_registration_link
            : webinar.video_actual !== ""
            ? `https://demyst.com${linksConstants.WEBINARS_VIDEO_SLUGIFIED.split("/:")[0]}/${
                webinar.video_actual.split("/").reverse()[0]
              }--${slugify(webinar.title)}`
            : webinar.video_external_url,
        ).pathname
      }
      className="webinars_list-item"
    >
      <div className="webinars_list-text_container">
        <div className={clsx("webinars_list-label", upcoming && "upcoming")}>
          {upcoming ? (
            <FiRadio className="webinars_list-icon" />
          ) : (
            <FiTv className="webinars_list-icon" />
          )}
          <p className="webinars_list-upcomingLabel">{upcoming ? "Upcoming!" : "On-demand"}</p>
        </div>
        <p className="webinars_list-published">
          {format(date, "LLLL dd, yyyy")}{" "}
          {upcoming && time && <span className="webinars_list-time"> at {time}</span>}
        </p>
        <h2 className="webinars_list-title">{webinar.title}</h2>
        <div className={clsx("webinars_list-button", upcoming && "upcoming")}>
          <span>{upcoming ? "Register Now" : "Watch"}</span>
          <FiArrowRight />
        </div>
      </div>
    </Link>
  );
};
